/**
 * Element IDs for `DevTools` components (src/components/DevTools/).
 */
export const devToolsElementIDs = {
  modalRoot: "dev-tools__modal-root",
  modalHeader: "dev-tools__modal-header",
  modalContent: "dev-tools__modal-content",
} as const;
